/* Triograf – configuratore calendari personalizzati (landing B2B) */
(function () {
  'use strict';

  var root = document.querySelector('[data-tgc-configurator]');
  if (!root) return;
  var cfgEl = document.getElementById('tgc-data');
  if (!cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var models = (cfg.models || []).filter(function (m) { return m && m.variantId; });

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  var money = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
  var unitFmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });

  var TYPE_LABELS = {
    olandesi: 'Olandesi da muro',
    silhouette: 'Silhouette',
    illustrati: 'Illustrati',
    tavolo: 'Da tavolo',
    trittici: 'Trittici',
  };

  var state = {
    model: null,
    filter: 'tutti',
    logoCanvas: null,
    logoUrl: '',
    logoName: '',
    logoKnockout: false,
    company: '',
    line2: '',
    layout: 'left',
    bg: '#ffffff',
    qty: Math.max(cfg.minQty || 100, 100),
    previewUrl: '',
    previewKey: '',
    aiUrl: '',
    aiRemaining: cfg.aiPerClient || 3,
    aiHeader: null,          // proposta di testata scelta: { url, img, style }
    aihProposals: [],
    aihRatio: 0,             // proporzioni della testata per cui sono state generate le proposte
    aihPhoto: null,
    aihRemaining: cfg.aiHeaderPerClient || 0,
    headerRatio: 0,
    started: false,
  };

  // ---------- identificativo anonimo del visitatore e parametri campagna ----------

  function clientId() {
    try {
      var id = localStorage.getItem('tg_cid');
      if (!id) {
        id = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2));
        localStorage.setItem('tg_cid', id);
      }
      return id;
    } catch (e) { return 'anon'; }
  }
  var CID = clientId();

  var attribution = (function () {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid'];
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('tg_attr') || '{}'); } catch (e) {}
    var params = new URLSearchParams(location.search);
    keys.forEach(function (k) { if (params.get(k)) stored[k] = params.get(k); });
    try { sessionStorage.setItem('tg_attr', JSON.stringify(stored)); } catch (e) {}
    return stored;
  })();

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function uid() {
    return (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2)).replace(/-/g, '').slice(0, 24);
  }

  // ---------- tracciamento (rispetta il consenso cookie di Shopify) ----------

  var track = {
    loaded: false,
    init: function () {
      var self = this;
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (!err) self.check();
        });
      }
      document.addEventListener('visitorConsentCollected', function () { self.check(); });
    },
    allowed: function () {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function') return false;
      return cp.marketingAllowed();
    },
    check: function () { if (this.allowed()) this.load(); },
    load: function () {
      if (this.loaded) return;
      this.loaded = true;
      // Le funzioni gtag/fbq accodano subito gli eventi; le librerie esterne si scaricano solo alla prima
      // interazione dell'utente, per non rallentare il caricamento della pagina.
      if (cfg.gadsId) {
        window.dataLayer = window.dataLayer || [];
        if (!window.gtag) {
          window.gtag = function () { window.dataLayer.push(arguments); };
          window.gtag('js', new Date());
        }
        window.gtag('config', cfg.gadsId, { send_page_view: false });
        if (cfg.ga4Id) window.gtag('config', cfg.ga4Id, { send_page_view: false });
      }
      if (cfg.pixelId && !window.fbq) {
        var n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!window._fbq) window._fbq = n;
        n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
        window.fbq('set', 'autoConfig', false, cfg.pixelId);
        window.fbq('init', cfg.pixelId);
      }
      var injected = false;
      function inject() {
        if (injected) return;
        injected = true;
        ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (ev) { window.removeEventListener(ev, inject, true); });
        if (cfg.gadsId) addScript('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(cfg.gadsId));
        if (cfg.pixelId) addScript('https://connect.facebook.net/en_US/fbevents.js');
      }
      function addScript(src) {
        var sc = document.createElement('script');
        sc.async = true;
        sc.src = src;
        document.head.appendChild(sc);
      }
      ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (ev) { window.addEventListener(ev, inject, { capture: true, passive: true }); });
    },
    meta: function (name, params, eventId) {
      if (!this.loaded || !window.fbq) return;
      window.fbq('track', name, params || {}, eventId ? { eventID: eventId } : undefined);
    },
    google: function (name, params, label, eventId) {
      if (!this.loaded || !window.gtag) return;
      window.gtag('event', name, params || {});
      if (label && cfg.gadsId) {
        var p = { send_to: cfg.gadsId + '/' + label };
        if (params && params.value) { p.value = params.value; p.currency = 'EUR'; }
        if (eventId) p.transaction_id = eventId;
        window.gtag('event', 'conversion', p);
      }
    },
    server: function (type, meta) {
      try {
        fetch(cfg.api + '/api/event', {
          method: 'POST', keepalive: true, mode: 'cors',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({ type: type, model: state.model ? state.model.title : '', client: CID, meta: meta || {} }),
        }).catch(function () {});
      } catch (e) {}
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('tg_' + type, { model: state.model ? state.model.title : '', meta: meta || {} });
        }
      } catch (e) {}
    },
  };
  track.init();

  function markStarted() {
    if (state.started) return;
    state.started = true;
    track.server('config_start');
    // se l'anteprima ambientata non è disponibile (es. crediti esauriti) il blocco non viene mostrato
    var aiBox = $('.tgc-ai');
    if (aiBox && cfg.api) {
      fetch(cfg.api + '/api/ai-status', { mode: 'cors' }).then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.available === false) {
            aiBox.hidden = true;
            if ($('[data-tgc-aih]')) $('[data-tgc-aih]').hidden = true;
          }
        }).catch(function () {});
    }
  }

  // ---------- selezione modello ----------

  function modelType(m) {
    if (m.type && TYPE_LABELS[m.type]) return m.type;
    var t = (m.title || '').toLowerCase();
    if (/tavolo|table/.test(t)) return 'tavolo';
    if (/trittico|quadrittico/.test(t)) return 'trittici';
    if (/silhouette|slim/.test(t)) return 'silhouette';
    if (/illustrat/.test(t)) return 'illustrati';
    return 'olandesi';
  }
  models.forEach(function (m) { m.type = modelType(m); });

  function renderFilters() {
    var box = $('[data-tgc-filters]');
    var types = ['tutti'].concat(Object.keys(TYPE_LABELS).filter(function (t) {
      return models.some(function (m) { return m.type === t; });
    }));
    box.innerHTML = '';
    types.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tgc-chip';
      b.textContent = t === 'tutti' ? 'Tutti (' + tiles().length + ')' : TYPE_LABELS[t];
      b.setAttribute('aria-pressed', String(state.filter === t));
      b.addEventListener('click', function () { state.filter = t; renderFilters(); renderModels(); });
      box.appendChild(b);
    });
  }

  // I colori dello stesso modello (campo "gruppo") diventano un solo riquadro: si sceglie il colore sotto i modelli.
  function groupOf(m) { return m.group || ''; }
  function membersOf(m) {
    return groupOf(m) ? models.filter(function (x) { return groupOf(x) === groupOf(m); }) : [m];
  }
  function tiles() {
    var seen = {}, out = [];
    models.forEach(function (m) {
      var g = groupOf(m);
      if (!g) { out.push(m); return; }
      if (seen[g]) return;
      seen[g] = true;
      var cur = state.model && groupOf(state.model) === g ? state.model : m;
      out.push(cur);
    });
    return out;
  }

  var COLOR_SWATCH = { blu: '#1f5fb0', rosso: '#d32f2f', verde: '#2e9d4f', nero: '#1b1b1b', azzurro: '#3aa0de' };
  function renderColors() {
    var box = $('[data-tgc-colors]');
    if (!box) return;
    var m = state.model;
    var list = m ? membersOf(m) : [];
    box.innerHTML = '';
    box.hidden = list.length < 2;
    if (list.length < 2) return;
    var label = document.createElement('span');
    label.className = 'tgc-label';
    label.textContent = 'Colore:';
    box.appendChild(label);
    list.forEach(function (x) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tgc-chip tgc-color';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', String(x.variantId === m.variantId));
      b.innerHTML = '<i aria-hidden="true"></i><span></span>';
      b.querySelector('i').style.background = COLOR_SWATCH[(x.color || '').toLowerCase()] || '#999';
      b.querySelector('span').textContent = x.color || x.title;
      b.addEventListener('click', function () { if (x !== state.model) selectModel(x); });
      b.addEventListener('pointerenter', function () { loadMockup(x); }, { once: true });
      box.appendChild(b);
    });
  }

  function renderModels() {
    var box = $('[data-tgc-models]');
    box.innerHTML = '';
    tiles().filter(function (m) { return state.filter === 'tutti' || m.type === state.filter; }).forEach(function (m) {
      var b = document.createElement('button');
      var grouped = membersOf(m).length > 1;
      b.type = 'button';
      b.className = 'tgc-model';
      b.setAttribute('data-type', m.type);
      b.setAttribute('aria-pressed', String(!!(state.model && (state.model.variantId === m.variantId || (grouped && groupOf(state.model) === groupOf(m))))));
      b.innerHTML =
        '<img loading="lazy" width="300" height="300" alt="" src="' + escAttr(m.thumb || m.image || m.mockup || '') + '">' +
        '<span class="tgc-model__t"></span><span class="tgc-model__f"></span><span class="tgc-model__p"></span>';
      b.querySelector('.tgc-model__t').textContent = grouped ? groupOf(m) : m.title;
      b.querySelector('.tgc-model__f').textContent = [TYPE_LABELS[m.type], m.format, grouped && membersOf(m).length + ' colori'].filter(Boolean).join(' · ');
      b.querySelector('.tgc-model__p').textContent = unitFmt.format(m.price / 100) + ' /pz + IVA';
      b.querySelector('img').alt = grouped ? groupOf(m) : m.title;
      b.addEventListener('click', function () { selectModel(m); });
      // precarica il mockup appena l'utente si avvicina al modello
      b.addEventListener('pointerenter', function () { loadMockup(m); }, { once: true });
      b.addEventListener('focus', function () { loadMockup(m); }, { once: true });
      box.appendChild(b);
    });
  }

  function selectModel(m, silent) {
    if (!silent) markStarted();
    state.model = m;
    state.aiUrl = '';
    renderModels();
    renderColors();
    $('[data-tgc-model-name]').textContent = m.title;
    var specs = [m.format && ('Formato ' + m.format), m.paper, m.printArea && ('Area di stampa ' + m.printArea)].filter(Boolean);
    $('[data-tgc-model-specs]').textContent = specs.join(' · ');
    $('[data-tgc-model-link]').href = m.url;
    $('[data-tgc-model-info]').hidden = false;
    if (!silent) setStep(2);
    loadMockup(m).then(draw);
    updateSummary();
  }

  // ---------- caricamento logo ----------

  var drop = $('[data-tgc-drop]');
  var fileInput = $('[data-tgc-file]');

  drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
  drop.addEventListener('dragleave', function () { drop.classList.remove('is-over'); });
  drop.addEventListener('drop', function (e) {
    e.preventDefault();
    drop.classList.remove('is-over');
    if (e.dataTransfer.files && e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
  });
  drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); } });
  fileInput.addEventListener('change', function () { if (fileInput.files[0]) handleFile(fileInput.files[0]); });

  function handleFile(file) {
    markStarted();
    showError('[data-tgc-logo-err]', '');
    var name = (file.name || '').toLowerCase();
    if (/\.(pdf|ai|eps|cdr|psd)$/.test(name) || file.type === 'application/pdf') {
      showError('[data-tgc-logo-err]', 'Per anteprima usa un file PNG, JPG o SVG. Il file vettoriale (PDF, AI, EPS) mandacelo pure via email o WhatsApp: lo useremo per la stampa.');
      return;
    }
    if (!/^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(file.type) && !/\.(png|jpe?g|webp|svg|gif)$/.test(name)) {
      showError('[data-tgc-logo-err]', 'Formato non supportato. Carica un logo PNG, JPG, WEBP o SVG.');
      return;
    }
    if (file.size > 15 * 1024 * 1024) {
      showError('[data-tgc-logo-err]', 'Il file è troppo grande (massimo 15 MB).');
      return;
    }
    var isSvg = file.type === 'image/svg+xml' || /\.svg$/.test(name);
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var w = img.naturalWidth || 1200, h = img.naturalHeight || 600;
      var maxSide = 1600;
      var scale = isSvg ? (maxSide / Math.max(w, h)) : Math.min(1, maxSide / Math.max(w, h));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(w * scale));
      c.height = Math.max(1, Math.round(h * scale));
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      state.logoCanvas = trimCanvas(c);
      state.logoName = file.name;
      state.logoUrl = '';
      state.aiUrl = ''; manualHeader();
      drop.classList.add('has-logo');
      drop.innerHTML = '';
      var thumb = new Image();
      thumb.alt = 'Logo caricato';
      thumb.src = state.logoCanvas.toDataURL('image/png');
      var txt = document.createElement('div');
      txt.innerHTML = '<strong></strong><span>Clicca per cambiare logo</span>';
      txt.querySelector('strong').textContent = file.name;
      drop.appendChild(thumb);
      drop.appendChild(txt);
      drop.appendChild(fileInput);
      $('[data-tgc-knockout-wrap]').hidden = isSvg || file.type === 'image/png' && hasTransparency(state.logoCanvas);
      uploadLogo();
      track.server('logo_upload', { type: file.type });
      draw();
    };
    img.onerror = function () { URL.revokeObjectURL(url); showError('[data-tgc-logo-err]', 'Non riesco a leggere questo file. Prova con un PNG o JPG.'); };
    img.src = url;
  }

  function hasTransparency(c) {
    try {
      var d = c.getContext('2d').getImageData(0, 0, c.width, c.height).data;
      for (var i = 3; i < d.length; i += 4 * 7) if (d[i] < 250) return true;
    } catch (e) {}
    return false;
  }

  // Rimuove i bordi vuoti (trasparenti o bianchi) intorno al logo
  function trimCanvas(c) {
    var ctx = c.getContext('2d');
    var d;
    try { d = ctx.getImageData(0, 0, c.width, c.height).data; } catch (e) { return c; }
    var w = c.width, h = c.height, top = h, left = w, right = -1, bottom = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4;
        var empty = d[i + 3] < 10 || (d[i] > 248 && d[i + 1] > 248 && d[i + 2] > 248);
        if (!empty) {
          if (x < left) left = x;
          if (x > right) right = x;
          if (y < top) top = y;
          if (y > bottom) bottom = y;
        }
      }
    }
    if (right < 0) return c;
    var pad = Math.round(Math.max(w, h) * 0.01);
    left = Math.max(0, left - pad); top = Math.max(0, top - pad);
    right = Math.min(w - 1, right + pad); bottom = Math.min(h - 1, bottom + pad);
    var out = document.createElement('canvas');
    out.width = right - left + 1;
    out.height = bottom - top + 1;
    out.getContext('2d').drawImage(c, left, top, out.width, out.height, 0, 0, out.width, out.height);
    return out;
  }

  function knockoutWhite(c) {
    var out = document.createElement('canvas');
    out.width = c.width; out.height = c.height;
    var ctx = out.getContext('2d');
    ctx.drawImage(c, 0, 0);
    try {
      var img = ctx.getImageData(0, 0, out.width, out.height);
      var d = img.data;
      for (var i = 0; i < d.length; i += 4) {
        var m = Math.min(d[i], d[i + 1], d[i + 2]);
        if (m > 235) d[i + 3] = Math.round(d[i + 3] * Math.max(0, (255 - m) / 20));
      }
      ctx.putImageData(img, 0, 0);
    } catch (e) {}
    return out;
  }

  function uploadBlob(blob) {
    return fetch(cfg.api + '/api/upload', { method: 'POST', mode: 'cors', headers: { 'Content-Type': blob.type }, body: blob })
      .then(function (r) { if (!r.ok) throw new Error('upload'); return r.json(); })
      .then(function (d) { return d.url; });
  }

  function uploadLogo() {
    if (!state.logoCanvas) return Promise.resolve('');
    if (state.logoUrl) return Promise.resolve(state.logoUrl);
    return canvasBlob(state.logoCanvas, 'image/png').then(uploadBlob).then(function (u) { state.logoUrl = u; return u; }).catch(function () { return ''; });
  }

  // ---------- testi e stile ----------

  $('[data-tgc-company]').addEventListener('input', function (e) { state.company = e.target.value; state.aiUrl = ''; manualHeader(); markStarted(); scheduleDraw(); });
  $('[data-tgc-line2]').addEventListener('input', function (e) { state.line2 = e.target.value; state.aiUrl = ''; manualHeader(); scheduleDraw(); });
  $('[data-tgc-knockout]').addEventListener('change', function (e) { state.logoKnockout = e.target.checked; state.aiUrl = ''; manualHeader(); draw(); });
  $$('[data-tgc-layout] button').forEach(function (b) {
    b.addEventListener('click', function () {
      state.layout = b.getAttribute('data-value');
      $$('[data-tgc-layout] button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      state.aiUrl = ''; manualHeader();
      draw();
    });
  });
  $$('[data-tgc-bg] .tgc-swatch').forEach(function (b) {
    b.addEventListener('click', function () { setBg(b.getAttribute('data-color')); });
  });
  $('[data-tgc-bg-custom]').addEventListener('input', function (e) { setBg(e.target.value); });
  function setBg(c) {
    state.bg = c;
    state.aiUrl = ''; manualHeader();
    $$('[data-tgc-bg] .tgc-swatch').forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-color') === c)); });
    draw();
  }

  // ---------- disegno dell'anteprima ----------

  var canvas = $('[data-tgc-canvas]');
  var mockCache = {};
  var drawTimer = null;
  function scheduleDraw() { clearTimeout(drawTimer); drawTimer = setTimeout(draw, 120); }

  function loadMockup(m) {
    var src = m.mockup || '';
    if (!src) return Promise.resolve(null);
    if (mockCache[src]) return mockCache[src];
    mockCache[src] = new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
    return mockCache[src];
  }

  function contrastText(hex) {
    var h = hex.replace('#', '');
    if (h.length === 3) h = h.split('').map(function (x) { return x + x; }).join('');
    var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 150 ? '#14232b' : '#ffffff';
  }

  function fitText(ctx, text, maxW, maxH, weight) {
    var size = Math.floor(maxH);
    while (size > 6) {
      ctx.font = weight + ' ' + size + 'px Arial, Helvetica, sans-serif';
      if (ctx.measureText(text).width <= maxW) break;
      size -= 1;
    }
    return size;
  }

  function drawHeader(ctx, x, y, w, h) {
    ctx.save();
    if (state.aiHeader && state.aiHeader.img) {
      // proposta grafica dell'AI: riempie tutta la testata, ritagliando il fondo in eccesso sopra e sotto
      drawCover(ctx, state.aiHeader.img, x, y, w, h, state.aiHeader.offset);
      ctx.restore();
      return;
    }
    ctx.fillStyle = state.bg;
    ctx.fillRect(x, y, w, h);
    var color = contrastText(state.bg);
    var logo = state.logoCanvas ? (state.logoKnockout ? knockoutWhite(state.logoCanvas) : state.logoCanvas) : null;
    var name = state.company.trim();
    var line2 = state.line2.trim();
    var pad = Math.min(w, h) * 0.12;
    var ix = x + pad, iy = y + pad, iw = w - 2 * pad, ih = h - 2 * pad;
    var thin = w / h > 5;
    ctx.fillStyle = color;
    ctx.textBaseline = 'middle';

    if (!logo && !name && !line2) {
      ctx.strokeStyle = 'rgba(16,57,72,.35)';
      ctx.setLineDash([Math.max(4, w / 80), Math.max(4, w / 80)]);
      ctx.lineWidth = Math.max(1, w / 400);
      ctx.strokeRect(ix, iy, iw, ih);
      ctx.setLineDash([]);
      ctx.fillStyle = 'rgba(16,57,72,.55)';
      ctx.textAlign = 'center';
      fitText(ctx, 'IL TUO LOGO QUI', iw * 0.8, ih * 0.32, '700');
      ctx.fillText('IL TUO LOGO QUI', x + w / 2, y + h / 2);
      ctx.restore();
      return;
    }

    var hasText = !!(name || line2);
    if (state.layout === 'center' && !thin) {
      var logoH = hasText ? ih * 0.62 : ih;
      if (logo) drawContain(ctx, logo, ix, iy, iw, logoH, 'center');
      if (hasText) {
        ctx.textAlign = 'center';
        var ty = logo ? iy + logoH + (ih - logoH) * 0.5 : iy + ih / 2;
        var tH = logo ? (ih - logoH) : ih;
        if (name && line2) {
          var s1 = fitText(ctx, name, iw, tH * 0.55, '700');
          ctx.fillText(name, x + w / 2, ty - tH * 0.22);
          fitText(ctx, line2, iw, Math.min(s1 * 0.7, tH * 0.38), '400');
          ctx.fillText(line2, x + w / 2, ty + tH * 0.26);
        } else {
          var t = name || line2;
          fitText(ctx, t, iw, tH * 0.8, name ? '700' : '400');
          ctx.fillText(t, x + w / 2, ty);
        }
      }
    } else {
      var logoW = logo ? (hasText ? iw * (thin ? 0.3 : 0.42) : iw) : 0;
      if (logo) drawContain(ctx, logo, ix, iy, logoW, ih, hasText ? 'left' : 'center');
      if (hasText) {
        var tx = ix + logoW + (logo ? iw * 0.05 : 0);
        var tw = ix + iw - tx;
        ctx.textAlign = logo ? 'left' : 'center';
        var ax = logo ? tx : x + w / 2;
        if (name && line2) {
          var sz = fitText(ctx, name, tw, ih * 0.42, '700');
          ctx.fillText(name, ax, iy + ih * 0.32);
          fitText(ctx, line2, tw, Math.min(sz * 0.72, ih * 0.3), '400');
          ctx.fillText(line2, ax, iy + ih * 0.74);
        } else {
          var tt = name || line2;
          fitText(ctx, tt, tw, ih * 0.5, name ? '700' : '400');
          ctx.fillText(tt, ax, iy + ih / 2);
        }
      }
    }
    ctx.restore();
  }

  // offset: 0 = ritaglio in alto, 0.5 = al centro, 1 = in basso
  function drawCover(ctx, img, x, y, w, h, offset) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    var r = Math.max(w / iw, h / ih);
    var sw = w / r, sh = h / r;
    var oy = offset === undefined ? 0.5 : offset;
    ctx.drawImage(img, (iw - sw) / 2, (ih - sh) * oy, sw, sh, x, y, w, h);
  }

  function drawContain(ctx, img, x, y, w, h, align) {
    var r = Math.min(w / img.width, h / img.height);
    var dw = img.width * r, dh = img.height * r;
    var dx = align === 'left' ? x : x + (w - dw) / 2;
    ctx.drawImage(img, dx, y + (h - dh) / 2, dw, dh);
  }

  // Calendario generico disegnato (usato se il modello non ha un mockup)
  function drawGeneric(ctx, m) {
    var desk = m.type === 'tavolo';
    var W = desk ? 1400 : 900, H = desk ? 1000 : 1400;
    canvas.width = W; canvas.height = H;
    ctx.clearRect(0, 0, W, H);
    var months = ['GENNAIO', 'FEBBRAIO', 'MARZO'];
    if (desk) {
      ctx.fillStyle = '#e9ecee';
      ctx.beginPath(); ctx.moveTo(140, 930); ctx.lineTo(1260, 930); ctx.lineTo(1170, 160); ctx.lineTo(230, 160); ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(230, 120, 940, 640);
      ctx.strokeStyle = '#d5dade'; ctx.lineWidth = 2; ctx.strokeRect(230, 120, 940, 640);
      for (var k = 0; k < 24; k++) { ctx.fillStyle = '#9aa5ab'; ctx.fillRect(260 + k * 37, 104, 10, 30); }
      drawMonthGrid(ctx, 270, 170, 860, 560, 'GENNAIO 2027');
      drawHeader(ctx, 160, 790, 1080, 130);
      return { x: 160, y: 790, w: 1080, h: 130 };
    }
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(80, 40, 740, 1320);
    ctx.strokeStyle = '#d5dade'; ctx.lineWidth = 2; ctx.strokeRect(80, 40, 740, 1320);
    var hdr = { x: 80, y: 40, w: 740, h: 300 };
    drawHeader(ctx, hdr.x, hdr.y, hdr.w, hdr.h);
    drawMonthGrid(ctx, 120, 380, 660, 940, months[0] + ' 2027');
    return hdr;
  }

  function drawMonthGrid(ctx, x, y, w, h, title) {
    ctx.fillStyle = '#103948';
    ctx.fillRect(x, y, w, h * 0.1);
    ctx.fillStyle = '#ffffff';
    ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
    ctx.font = '700 ' + Math.round(h * 0.055) + 'px Arial, Helvetica, sans-serif';
    ctx.fillText(title, x + w * 0.04, y + h * 0.05);
    var days = ['L', 'M', 'M', 'G', 'V', 'S', 'D'];
    var cw = w / 7, top = y + h * 0.14, rh = (h * 0.84) / 6;
    ctx.font = '700 ' + Math.round(rh * 0.3) + 'px Arial, Helvetica, sans-serif';
    ctx.textAlign = 'center';
    days.forEach(function (d, i) { ctx.fillStyle = i === 6 ? '#bc5631' : '#5b6f78'; ctx.fillText(d, x + cw * i + cw / 2, top); });
    // gennaio 2027 inizia di venerdì
    var day = 1, start = 4;
    for (var r = 0; r < 6; r++) {
      for (var c = 0; c < 7; c++) {
        var idx = r * 7 + c;
        if (idx < start || day > 31) continue;
        ctx.fillStyle = c === 6 ? '#bc5631' : '#14232b';
        ctx.font = '400 ' + Math.round(rh * 0.42) + 'px Arial, Helvetica, sans-serif';
        ctx.fillText(String(day), x + cw * c + cw / 2, top + rh * (r + 0.85));
        day++;
      }
    }
  }

  function draw() {
    var m = state.model;
    var stage = $('[data-tgc-stage]');
    if (!m) return;
    $('[data-tgc-empty]').hidden = true;
    canvas.hidden = false;
    $('[data-tgc-ai-img]').hidden = true;
    var ctx = canvas.getContext('2d');
    stage.setAttribute('data-ready', '0');
    loadMockup(m).then(function (img) {
      if (state.model !== m) return;
      if (!img || !m.area) {
        drawGeneric(ctx, m);
      } else {
        var maxSide = 1400;
        var s = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
        canvas.width = Math.round(img.naturalWidth * s);
        canvas.height = Math.round(img.naturalHeight * s);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        var a = m.area;
        var ax = canvas.width * a.x / 100, ay = canvas.height * a.y / 100;
        var aw = canvas.width * a.w / 100, ah = canvas.height * a.h / 100;
        setHeaderRatio(aw / ah);
        if (a.r) {
          // area inclinata (piedino dei calendari da tavolo in prospettiva)
          ctx.save();
          ctx.translate(ax + aw / 2, ay + ah / 2);
          ctx.rotate(a.r * Math.PI / 180);
          drawHeader(ctx, -aw / 2, -ah / 2, aw, ah);
          ctx.restore();
        } else {
          drawHeader(ctx, ax, ay, aw, ah);
        }
      }
      state.previewKey = '';
      stage.setAttribute('data-ready', '1');
      updateSteps();
    });
  }

  function canvasBlob(c, type, q) {
    return new Promise(function (resolve, reject) {
      c.toBlob(function (b) { b ? resolve(b) : reject(new Error('blob')); }, type || 'image/png', q);
    });
  }

  function previewSignature() {
    return [state.model && state.model.variantId, state.logoName, state.logoKnockout, state.company, state.line2, state.layout, state.bg,
      state.aiHeader ? state.aiHeader.url : ''].join('|');
  }

  function ensurePreviewUrl() {
    if (!state.model) return Promise.resolve('');
    var sig = previewSignature();
    if (state.previewUrl && state.previewKey === sig) return Promise.resolve(state.previewUrl);
    return canvasBlob(canvas, 'image/jpeg', 0.9).then(uploadBlob).then(function (u) {
      state.previewUrl = u;
      state.previewKey = sig;
      return u;
    }).catch(function () { return ''; });
  }

  // ---------- anteprima ambientata (AI) ----------

  var aiBtn = $('[data-tgc-ai-btn]');
  if (aiBtn) {
    aiBtn.addEventListener('click', function () {
      if (!state.model) return;
      if (!state.logoCanvas && !state.company.trim()) {
        showError('[data-tgc-ai-err]', 'Carica il logo o scrivi il nome dell’azienda prima di generare l’anteprima.');
        return;
      }
      showError('[data-tgc-ai-err]', '');
      var scene = $('[data-tgc-scene]').value;
      var loading = $('[data-tgc-loading]');
      loading.hidden = false;
      aiBtn.disabled = true;
      canvasBlob(canvas, 'image/jpeg', 0.92).then(function (blob) {
        var q = '?scene=' + encodeURIComponent(scene) + '&kind=' + (state.model.type === 'tavolo' ? 'tavolo' : 'muro') + '&model=' + encodeURIComponent(state.model.title);
        return fetch(cfg.api + '/api/ai-preview' + q, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'image/jpeg', 'X-Client-Id': CID }, body: blob });
      }).then(function (r) {
        var rem = r.headers.get('X-Remaining');
        return r.json().then(function (d) { return { ok: r.ok, d: d, rem: rem }; });
      }).then(function (res) {
        if (res.d && res.d.error === 'ai_non_disponibile') {
          $('.tgc-ai__row').hidden = true;
          $('[data-tgc-ai-left]').hidden = true;
        }
        if (!res.ok || !res.d.data || !res.d.data[0]) {
          throw new Error((res.d && res.d.message) || 'Non è stato possibile generare l’anteprima. Riprova tra poco.');
        }
        if (res.rem !== null) state.aiRemaining = parseInt(res.rem, 10);
        var dataUrl = 'data:image/png;base64,' + res.d.data[0].b64_json;
        var img = $('[data-tgc-ai-img]');
        img.src = dataUrl;
        img.hidden = false;
        canvas.hidden = true;
        $('[data-tgc-view]').hidden = false;
        track.meta('CustomizeProduct', { content_name: state.model.title });
        track.google('customize_product', { item_name: state.model.title });
        return fetch(dataUrl).then(function (r) { return r.blob(); }).then(uploadBlob).then(function (u) { state.aiUrl = u; });
      }).catch(function (e) {
        showError('[data-tgc-ai-err]', e.message);
      }).then(function () {
        loading.hidden = true;
        aiBtn.disabled = state.aiRemaining <= 0;
        $('[data-tgc-ai-left]').textContent = state.aiRemaining > 0
          ? 'Anteprime ambientate disponibili oggi: ' + state.aiRemaining
          : 'Hai usato le anteprime ambientate di oggi. L’anteprima del calendario resta sempre disponibile.';
      });
    });
    $$('[data-tgc-view] button').forEach(function (b) {
      b.addEventListener('click', function () {
        var ai = b.getAttribute('data-v') === 'ai';
        $('[data-tgc-ai-img]').hidden = !ai;
        canvas.hidden = ai;
        $$('[data-tgc-view] button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
    });
  }

  // ---------- proposte di testata (AI) ----------

  var aihBox = $('[data-tgc-aih]');
  var AIH_MAX_RATIO = 6.5; // oltre (piedino dei calendari da tavolo) la testata è troppo sottile per una grafica generata
  var AIH_LABELS = { pulito: 'Proposta pulita', deciso: 'Proposta decisa', dinamico: 'Proposta dinamica' };

  // le proposte valgono per testate di forma simile a quella per cui sono state create
  function aihCompatible(r) {
    if (!state.aihRatio || !r) return false;
    if (state.aihRatio >= 3 && r >= 3) return r <= AIH_MAX_RATIO;
    return Math.abs(Math.log(r / state.aihRatio)) < 0.25;
  }

  // modifiche a logo, testi o colori: si torna all'impaginazione manuale (le proposte restano selezionabili)
  function manualHeader() {
    if (!state.aiHeader) return;
    state.aiHeader = null;
    if (aihBox) renderAih();
  }

  function setHeaderRatio(r) {
    state.headerRatio = r;
    if (!aihBox) return;
    var tooThin = r > AIH_MAX_RATIO;
    var btn = $('[data-tgc-aih-btn]');
    btn.disabled = tooThin || state.aihRemaining <= 0;
    if (state.aihProposals.length && !aihCompatible(r)) {
      // nuovo formato di testata: le proposte precedenti non si adattano più
      state.aihProposals = [];
      state.aiHeader = null;
      renderAih();
    }
    if (state.aihProposals.length && Math.abs(r - (state.aihOffsetRatio || 0)) > 0.01) {
      state.aihOffsetRatio = r;
      state.aihProposals.forEach(function (o) { o.offset = cropOffset(o.img, r); });
      renderAih();
    }
    aihNote(tooThin ? 'Per i calendari da tavolo la grafica della base la prepara il nostro studio nella bozza gratuita.' : '');
  }

  function aihNote(extra) {
    var left = $('[data-tgc-aih-left]');
    if (!left) return;
    var base = state.aihRemaining > 0
      ? 'Richieste di proposte disponibili oggi: ' + state.aihRemaining + ' (3 grafiche ciascuna).'
      : 'Hai usato le proposte grafiche di oggi: puoi scegliere tra quelle create o impaginare la testata a mano.';
    left.textContent = extra || base;
  }

  function scaledBlob(src, maxSide, type, q) {
    var w = src.naturalWidth || src.width, h = src.naturalHeight || src.height;
    var s = Math.min(1, maxSide / Math.max(w, h));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * s));
    c.height = Math.max(1, Math.round(h * s));
    var ctx = c.getContext('2d');
    if (type === 'image/jpeg') { ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height); }
    ctx.drawImage(src, 0, 0, c.width, c.height);
    return canvasBlob(c, type, q);
  }

  // Se l'AI non ha tenuto tutto nella fascia centrale, sposta il ritaglio verso le scritte invece di tagliarle:
  // conta i bordi molto netti (tipici del testo) riga per riga e sceglie la finestra che ne contiene di più.
  function cropOffset(img, ratio) {
    var iw = img.naturalWidth, ih = img.naturalHeight;
    var winH = iw / ratio;
    if (!ratio || winH >= ih) return 0.5;
    var sw = 192, sh = Math.max(16, Math.round(ih * sw / iw));
    var c = document.createElement('canvas');
    c.width = sw; c.height = sh;
    var cx = c.getContext('2d');
    cx.drawImage(img, 0, 0, sw, sh);
    var d;
    try { d = cx.getImageData(0, 0, sw, sh).data; } catch (e) { return 0.5; }
    var rows = new Float32Array(sh);
    for (var y = 1; y < sh; y++) {
      for (var x = 1; x < sw; x++) {
        var p = (y * sw + x) * 4, l = p - 4, u = p - sw * 4;
        var g = Math.abs(d[p] - d[l]) + Math.abs(d[p + 1] - d[l + 1]) + Math.abs(d[p + 2] - d[l + 2]) +
          Math.abs(d[p] - d[u]) + Math.abs(d[p + 1] - d[u + 1]) + Math.abs(d[p + 2] - d[u + 2]);
        if (g > 260) rows[y] += 1;
      }
    }
    var wh = Math.round(winH * sh / ih), best = -1, top = Math.round((sh - wh) / 2);
    for (var t = 0; t + wh <= sh; t++) {
      var sum = 0;
      for (var k = t; k < t + wh; k++) sum += rows[k];
      sum *= 1 - Math.abs((t + wh / 2) / sh - 0.5) * 0.4;
      if (sum > best) { best = sum; top = t; }
    }
    return sh > wh ? top / (sh - wh) : 0.5;
  }

  function loadProposals(list) {
    return Promise.all(list.map(function (o) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { resolve({ url: o.url, style: o.style, img: img, offset: cropOffset(img, state.headerRatio) }); };
        img.onerror = function () { resolve(null); };
        img.src = o.url;
      });
    })).then(function (r) { return r.filter(Boolean); });
  }

  function renderAih() {
    var list = $('[data-tgc-aih-list]');
    list.innerHTML = '';
    list.hidden = !state.aihProposals.length;
    if (!state.aihProposals.length) return;
    var opts = state.aihProposals.concat([{ manual: true }]);
    opts.forEach(function (o, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tgc-aih__opt' + (o.manual ? ' tgc-aih__opt--manual' : '');
      b.setAttribute('role', 'radio');
      var selected = o.manual ? !state.aiHeader : !!(state.aiHeader && state.aiHeader.url === o.url);
      b.setAttribute('aria-checked', String(selected));
      if (o.manual) {
        b.innerHTML = '<span>Usa la mia impaginazione (logo e testi qui sopra)</span>';
      } else {
        b.innerHTML = '<img alt="" src="' + escAttr(o.url) + '" style="aspect-ratio:' + (state.headerRatio || 4) +
          ';object-position:50% ' + Math.round((o.offset === undefined ? 0.5 : o.offset) * 100) + '%"><span>' +
          escAttr((AIH_LABELS[o.style] || 'Proposta') + ' · ' + (i + 1)) + '</span>';
        b.setAttribute('aria-label', (AIH_LABELS[o.style] || 'Proposta') + ' ' + (i + 1));
      }
      b.addEventListener('click', function () { chooseAih(o.manual ? null : o); });
      list.appendChild(b);
    });
  }

  function chooseAih(o) {
    state.aiHeader = o || null;
    state.aiUrl = '';
    renderAih();
    draw();
    if (o) track.meta('CustomizeProduct', { content_name: state.model ? state.model.title : '', method: 'ai_header' });
  }

  if (aihBox) {
    if (!cfg.aiHeaderPerClient) aihBox.hidden = true;
    var photoInput = $('[data-tgc-aih-photo]');
    var photoLabel = $('[data-tgc-aih-photo-label]');
    var photoText = photoLabel.textContent;
    photoInput.addEventListener('change', function () {
      var f = photoInput.files[0];
      if (!f) return;
      if (!/^image\/(png|jpeg|webp)$/.test(f.type)) {
        showError('[data-tgc-aih-err]', 'Usa una foto JPG, PNG o WEBP.');
        return;
      }
      var url = URL.createObjectURL(f);
      var img = new Image();
      img.onload = function () {
        scaledBlob(img, 1536, 'image/jpeg', 0.9).then(function (blob) {
          state.aihPhoto = blob;
          showError('[data-tgc-aih-err]', '');
          photoLabel.innerHTML = '<img alt="" src="' + url + '"> Foto aggiunta';
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.textContent = 'Rimuovi';
          rm.addEventListener('click', function (e) {
            e.preventDefault();
            state.aihPhoto = null;
            photoInput.value = '';
            photoLabel.textContent = photoText;
            URL.revokeObjectURL(url);
          });
          photoLabel.appendChild(rm);
        });
      };
      img.onerror = function () { showError('[data-tgc-aih-err]', 'Non riesco a leggere questa foto. Prova con un JPG o PNG.'); };
      img.src = url;
    });

    $('[data-tgc-aih-btn]').addEventListener('click', function () {
      var btn = this;
      if (!state.model) return;
      if (!state.logoCanvas && !state.company.trim()) {
        showError('[data-tgc-aih-err]', 'Carica il logo o scrivi il nome dell’azienda prima di chiedere le proposte.');
        return;
      }
      showError('[data-tgc-aih-err]', '');
      markStarted();
      var loading = $('[data-tgc-aih-loading]');
      loading.hidden = false;
      btn.disabled = true;
      var ratio = state.headerRatio || 4.5;
      var logoSrc = state.logoCanvas ? (state.logoKnockout ? knockoutWhite(state.logoCanvas) : state.logoCanvas) : null;
      (logoSrc ? scaledBlob(logoSrc, 1024, 'image/png') : Promise.resolve(null)).then(function (logoBlob) {
        var fd = new FormData();
        if (logoBlob) fd.append('logo', logoBlob, 'logo.png');
        if (state.aihPhoto) fd.append('photo', state.aihPhoto, 'foto.jpg');
        fd.append('company', state.company.trim());
        fd.append('line2', state.line2.trim());
        fd.append('ratio', String(Math.round(ratio * 100) / 100));
        fd.append('model', state.model.title);
        return fetch(cfg.api + '/api/ai-header', { method: 'POST', mode: 'cors', headers: { 'X-Client-Id': CID }, body: fd });
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      }).then(function (res) {
        if (res.d && res.d.error === 'ai_non_disponibile') aihBox.hidden = true;
        if (res.d && typeof res.d.remaining === 'number') state.aihRemaining = res.d.remaining;
        if (res.d && res.d.error === 'limite_raggiunto') state.aihRemaining = 0;
        if (!res.ok || !res.d.proposals || !res.d.proposals.length) {
          throw new Error((res.d && res.d.message) || 'Non è stato possibile creare le proposte. Riprova tra poco.');
        }
        track.google('customize_product', { item_name: state.model.title, method: 'ai_header' });
        return loadProposals(res.d.proposals).then(function (list) {
          if (!list.length) throw new Error('Non riesco a caricare le proposte, riprova.');
          state.aihProposals = list;
          state.aihRatio = ratio;
          state.aihOffsetRatio = ratio;
          // mostra subito la prima proposta sul calendario: le altre si scelgono dall'elenco
          chooseAih(list[0]);
        });
      }).catch(function (e) {
        showError('[data-tgc-aih-err]', e.message);
      }).then(function () {
        loading.hidden = true;
        btn.disabled = state.aihRemaining <= 0 || state.headerRatio > AIH_MAX_RATIO;
        aihNote();
      });
    });
    aihNote();
  }

  $('[data-tgc-download]').addEventListener('click', function () {
    if (!state.model) return;
    var aiVisible = !$('[data-tgc-ai-img]').hidden;
    var a = document.createElement('a');
    a.download = 'anteprima-calendario-' + (state.model.handle || 'triograf') + '.png';
    a.href = aiVisible ? $('[data-tgc-ai-img]').src : canvas.toDataURL('image/png');
    document.body.appendChild(a); a.click(); a.remove();
  });

  // ---------- quantità e riepilogo ----------

  var qtyInput = $('[data-tgc-qty]');
  qtyInput.min = String(cfg.minQty);
  qtyInput.value = String(state.qty);
  qtyInput.addEventListener('input', function () {
    var v = parseInt(qtyInput.value, 10);
    state.qty = isNaN(v) ? 0 : v;
    updateSummary();
  });
  qtyInput.addEventListener('blur', function () {
    // si produce a multipli di qtyStep: si arrotonda per eccesso, mai sotto il minimo
    var step = cfg.qtyStep || 1;
    var q = Math.max(cfg.minQty, Math.ceil((state.qty || 0) / step) * step);
    if (q !== state.qty) { state.qty = q; qtyInput.value = String(q); updateSummary(); }
  });
  $$('[data-tgc-qty-quick] button').forEach(function (b) {
    b.addEventListener('click', function () {
      state.qty = parseInt(b.getAttribute('data-q'), 10);
      qtyInput.value = String(state.qty);
      updateSummary();
    });
  });

  // sconto quantità: il più alto tra gli scaglioni raggiunti ("300:2" = -2% da 300 pezzi)
  function discountFor(qty) {
    var d = 0;
    (cfg.tiers || []).forEach(function (t) {
      var p = String(t).split(':');
      if (qty >= parseInt(p[0], 10)) d = Math.max(d, parseFloat(p[1]) || 0);
    });
    return d;
  }

  function totals() {
    var unit = state.model ? state.model.price / 100 : 0;
    var qty = Math.max(state.qty || 0, 0);
    var gross0 = Math.round(unit * qty * 100) / 100;
    var disc = discountFor(qty);
    var discount = Math.round(gross0 * disc) / 100;
    var net = Math.round((gross0 - discount) * 100) / 100;
    var shipping = net >= (cfg.freeShippingFrom || 50) ? 0 : (cfg.shippingCost || 0);
    var vat = Math.round((net + shipping) * cfg.vat) / 100;
    return { unit: unit, qty: qty, disc: disc, discount: discount, net: net, shipping: shipping, vat: vat, gross: Math.round((net + shipping + vat) * 100) / 100 };
  }

  function updateSummary() {
    var t = totals();
    var step = cfg.qtyStep || 1;
    var ok = !!state.model && t.qty >= cfg.minQty && t.qty % step === 0;
    var showDisc = !!state.model && t.disc > 0;
    $('[data-tgc-sum-disc-label]').hidden = !showDisc;
    $('[data-tgc-sum-disc]').hidden = !showDisc;
    if (showDisc) $('[data-tgc-sum-disc]').textContent = '-' + t.disc + '% (−' + money.format(t.discount) + ')';
    $('[data-tgc-sum-model]').textContent = state.model ? state.model.title : '—';
    $('[data-tgc-sum-unit]').textContent = state.model ? unitFmt.format(t.unit) + ' + IVA' : '—';
    $('[data-tgc-sum-qty]').textContent = t.qty ? t.qty.toLocaleString('it-IT') + ' pz' : '—';
    $('[data-tgc-sum-net]').textContent = state.model ? money.format(t.net) : '—';
    $('[data-tgc-sum-ship]').textContent = state.model ? (t.shipping ? money.format(t.shipping) : 'Gratuita') : '—';
    $('[data-tgc-sum-vat]').textContent = state.model ? money.format(t.vat) : '—';
    $('[data-tgc-sum-tot]').textContent = state.model ? money.format(t.gross) : '—';
    var qErr = state.qty && state.qty < cfg.minQty ? 'La quantità minima è ' + cfg.minQty + ' pezzi.'
      : state.qty && state.qty % step ? 'Si ordina a multipli di ' + step + ' pezzi (es. ' + (Math.ceil(state.qty / step) * step) + ').' : '';
    showError('[data-tgc-qty-err]', qErr);
    $('[data-tgc-buy]').disabled = !ok;
    updateSteps();
  }

  // ---------- passi ----------

  function setStep(n) { root.setAttribute('data-step', String(n)); updateSteps(); }
  function updateSteps() {
    var done1 = !!state.model;
    var done2 = !!(state.logoCanvas || state.company.trim());
    var done3 = done1 && state.qty >= cfg.minQty && state.qty % (cfg.qtyStep || 1) === 0;
    $$('[data-tgc-steps] li').forEach(function (li, i) {
      var d = [done1, done2, done1 && done2, done3][i];
      li.classList.toggle('is-done', !!d);
    });
  }

  // ---------- messaggi per WhatsApp / email ----------

  function summaryText(links) {
    var t = totals();
    var lines = [
      'Modello: ' + (state.model ? state.model.title : 'da scegliere'),
      'Quantità: ' + (t.qty || '-') + ' pz',
    ];
    if (state.model && t.qty) lines.push('Totale indicativo: ' + money.format(t.net) + ' + IVA' + (t.disc ? ' (sconto quantità ' + t.disc + '% incluso)' : ''));
    if (state.company.trim()) lines.push('Azienda in testata: ' + state.company.trim());
    if (state.line2.trim()) lines.push('Seconda riga: ' + state.line2.trim());
    if (links.logo) lines.push('Logo: ' + links.logo);
    if (links.preview) lines.push('Anteprima: ' + links.preview);
    if (state.aiHeader) lines.push('Testata proposta dall’AI: ' + state.aiHeader.url);
    if (state.aiUrl) lines.push('Anteprima ambientata: ' + state.aiUrl);
    return lines.join('\n');
  }

  function collectLinks() {
    return Promise.all([uploadLogo(), state.model ? ensurePreviewUrl() : Promise.resolve('')]).then(function (r) {
      return { logo: r[0], preview: r[1] };
    });
  }

  function openLink(href, newTab) {
    if (newTab) {
      var w = window.open(href, '_blank', 'noopener');
      if (!w) location.href = href;
    } else {
      location.href = href;
    }
  }

  function onWhatsApp(e) {
    e.preventDefault();
    var btn = e.currentTarget;
    var eventId = uid();
    // Su mobile apriamo subito per non perdere il gesto utente; i link vengono aggiunti se pronti
    btn.setAttribute('aria-busy', 'true');
    collectLinks().then(function (links) {
      var msg = 'Ciao Triograf! Vorrei informazioni sui calendari personalizzati.\n' + summaryText(links) + '\n(dal configuratore su triograf.com)';
      track.meta('Contact', { content_name: state.model ? state.model.title : '', method: 'whatsapp' }, eventId);
      track.google('contact', { method: 'whatsapp' }, cfg.labels.whatsapp, eventId);
      track.server('whatsapp');
      btn.removeAttribute('aria-busy');
      openLink('https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent(msg), true);
    });
  }

  function onEmail(e) {
    e.preventDefault();
    var eventId = uid();
    collectLinks().then(function (links) {
      var subject = 'Richiesta calendari personalizzati' + (state.model ? ' – ' + state.model.title : '');
      var body = 'Buongiorno,\nvorrei ricevere informazioni sui calendari personalizzati.\n\n' + summaryText(links) +
        '\n\nRagione sociale:\nTelefono:\n\nGrazie';
      track.meta('Contact', { content_name: state.model ? state.model.title : '', method: 'email' }, eventId);
      track.google('contact', { method: 'email' }, cfg.labels.email, eventId);
      track.server('email');
      openLink('mailto:' + cfg.email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body), false);
    });
  }

  $$('[data-tgc-wa]').forEach(function (a) { a.addEventListener('click', onWhatsApp); });
  $$('[data-tgc-mail]').forEach(function (a) { a.addEventListener('click', onEmail); });
  document.querySelectorAll('[data-tgc-wa-global]').forEach(function (a) { a.addEventListener('click', onWhatsApp); });

  // ---------- acquisto ----------

  $('[data-tgc-buy]').addEventListener('click', function () {
    var btn = this;
    var t = totals();
    showError('[data-tgc-buy-err]', '');
    if (!state.model || t.qty < cfg.minQty || t.qty % (cfg.qtyStep || 1)) return;
    var company = $('[data-tgc-b2b-name]').value.trim();
    var vatId = $('[data-tgc-b2b-vat]').value.trim().replace(/\s+/g, '');
    var sdi = $('[data-tgc-b2b-sdi]').value.trim();
    if (!company || !/^(IT)?\d{11}$/i.test(vatId) || !sdi) {
      $('[data-tgc-b2b]').open = true;
      showError('[data-tgc-buy-err]', 'Per la fattura servono ragione sociale, partita IVA (11 cifre) e codice SDI o PEC.');
      return;
    }
    if (!state.logoCanvas && !state.company.trim()) {
      showError('[data-tgc-buy-err]', 'Carica il logo o scrivi il nome dell’azienda da stampare in testata.');
      return;
    }
    btn.disabled = true;
    btn.innerHTML = '<span class="tgc-spinner" aria-hidden="true"></span> Preparazione ordine…';
    collectLinks().then(function (links) {
      var props = {
        'Testo in testata': state.company.trim() || '—',
        'Seconda riga': state.line2.trim() || '—',
        'Logo': links.logo || 'da inviare via email',
        'Anteprima': links.preview || '—',
        '_Origine': 'Landing configuratore',
      };
      if (state.aiUrl) props['Anteprima ambientata'] = state.aiUrl;
      if (state.aiHeader) props['Testata grafica AI'] = state.aiHeader.url;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: state.model.variantId, quantity: t.qty, properties: props }] }),
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Impossibile aggiungere al carrello.'); });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: {
            'Ragione sociale': company, 'Partita IVA': vatId, 'Codice SDI o PEC': sdi,
            'Origine': 'Landing calendari personalizzati',
            'Campagna': [attribution.utm_source, attribution.utm_campaign].filter(Boolean).join(' / ') || (attribution.gclid ? 'google' : attribution.fbclid ? 'meta' : ''),
          } }),
        });
      }).then(function () {
        track.server('add_to_cart', { qty: t.qty, value: t.net });
        location.href = cfg.checkoutUrl || '/checkout';
      });
    }).catch(function (e) {
      showError('[data-tgc-buy-err]', e.message || 'Si è verificato un errore. Riprova o contattaci su WhatsApp.');
      btn.disabled = false;
      btn.textContent = 'Acquista ora';
    });
  });

  // ---------- modulo di ricontatto ----------

  var form = document.querySelector('[data-tgc-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var msgBox = form.querySelector('[data-tgc-form-msg]');
      msgBox.className = 'tgc-alert';
      msgBox.hidden = true;
      if (!fd.get('name') || !(fd.get('phone') || fd.get('email'))) {
        msgBox.textContent = 'Inserisci nome e almeno un recapito (telefono o email).';
        msgBox.className = 'tgc-alert tgc-alert--err';
        msgBox.hidden = false;
        return;
      }
      if (!fd.get('privacy')) {
        msgBox.textContent = 'Per inviare la richiesta devi accettare l’informativa privacy.';
        msgBox.className = 'tgc-alert tgc-alert--err';
        msgBox.hidden = false;
        return;
      }
      var submit = form.querySelector('[type="submit"]');
      submit.disabled = true;
      var eventId = uid();
      collectLinks().then(function (links) {
        var t = totals();
        var payload = {
          name: fd.get('name'), company: fd.get('company'), phone: fd.get('phone'), email: fd.get('email'),
          message: fd.get('message'), privacy: true, website: fd.get('website'),
          model: state.model ? state.model.title : '', qty: state.model ? String(t.qty) : '',
          preview_url: state.aiUrl || links.preview || '', event_id: eventId,
          utm: JSON.stringify(attribution), utm_campaign: attribution.utm_campaign || '',
          gclid: attribution.gclid || attribution.gbraid || attribution.wbraid || '', fbclid: attribution.fbclid || '',
          fbc: cookie('_fbc'), fbp: cookie('_fbp'), page: location.href.split('#')[0],
        };
        if (links.logo) payload.message = (payload.message ? payload.message + '\n' : '') + 'Logo: ' + links.logo;
        if (state.aiHeader) payload.message = (payload.message ? payload.message + '\n' : '') + 'Testata scelta (proposta AI): ' + state.aiHeader.url;
        return fetch(cfg.api + '/api/lead', { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { if (!r.ok) throw new Error('lead'); return r.json(); })
          .then(function () {
            var value = state.model ? Math.round(t.net) : undefined;
            track.meta('Lead', { content_name: payload.model, value: value, currency: 'EUR' }, eventId);
            track.google('generate_lead', { value: value, currency: 'EUR' }, cfg.labels.lead, eventId);
            form.reset();
            msgBox.textContent = 'Grazie! Abbiamo ricevuto la tua richiesta: ti contattiamo entro poche ore (anche su WhatsApp).';
            msgBox.className = 'tgc-alert tgc-alert--ok';
            msgBox.hidden = false;
          });
      }).catch(function () {
        msgBox.textContent = 'Non siamo riusciti a inviare la richiesta. Scrivici su WhatsApp o via email, ti rispondiamo subito.';
        msgBox.className = 'tgc-alert tgc-alert--err';
        msgBox.hidden = false;
      }).then(function () { submit.disabled = false; });
    });
    form.addEventListener('focusin', function once() {
      track.server('form_open');
      form.removeEventListener('focusin', once);
    });
  }

  // ---------- utilità ----------

  function showError(sel, text) {
    var el = typeof sel === 'string' ? (root.querySelector(sel) || document.querySelector(sel)) : sel;
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }
  function escAttr(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  // ---------- avvio ----------

  renderFilters();
  renderModels();
  updateSummary();
  // Modello preselezionato: da link (?modello=handle) oppure il predefinito, così l'anteprima non è mai vuota
  var params = new URLSearchParams(location.search);
  var pre = params.get('modello');
  var found = pre && models.filter(function (m) { return m.handle === pre; })[0];
  if (found) {
    selectModel(found);
  } else if (models.length) {
    selectModel(models.filter(function (m) { return m.handle === cfg.defaultHandle; })[0] || models[0], true);
  }
  if (cfg.aiPerClient) $('[data-tgc-ai-left]').textContent = 'Anteprime ambientate disponibili oggi: ' + cfg.aiPerClient;
})();
